// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__mDsVo","title":"ClientInsurance_title__3dTqI","itemText":"ClientInsurance_itemText__3mJPh"};